<h2>Пополнения</h2>
<div class="container refill-content">
  <div class="refill-data">
    <mat-form-field appearance="standard">
      <mat-label>Фильтр</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Например статус или провайдер" #input>
    </mat-form-field>

    <ng-container *ngIf="isGoFast then goFastTable; else hltvTable"></ng-container>

    <ng-template #goFastTable>
      <mat-table [dataSource]="userRefills" class="table refill-table" matSort>

        <!-- tid Column -->
        <ng-container matColumnDef="tid">
          <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.tid}} </mat-cell>
        </ng-container>

        <!-- status Column -->
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Статус</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="status-box" [ngClass]="element.statusText">
              <span
                matTooltip="{{
                  element.method === 'market'
                    ? ((fastOfferOrderStatusEnum[element.state] || ('state=' + (element.state ?? 'null')))
                        + ((element.error || element.reason) ? ' • ' + (element.error || element.reason) : ''))
                    : (paymentStatusLabels[element.status] || ('status=' + (element.status ?? 'null')))
                }}"
                matTooltipPosition="above">
                {{ element.statusText | uppercase }}
              </span>
            </div>
          </mat-cell>
        </ng-container>

        <!-- buyer Column -->
        <ng-container matColumnDef="buyer-email">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Buyer</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container  *ngIf="element.buyer || element.email; else empty">
              <ng-container *ngIf="element.buyer">
                <span class="ellipsis-text"><a [routerLink]="['/user/', element.buyer]">{{element.buyer}}</a></span>
              </ng-container>
              <ng-container *ngIf="element.email">
                <div class="email-container">
                  <a class="link" [routerLink]="['/payouts/wallet/', element.email]">
                    <span class="text-overflow">{{element.email}}</span></a>
                  <mat-icon class="icon"
                            matTooltip="Нажми чтобы скопировать"
                            matTooltipPosition="above"
                            (click)="clipboard.copy(element.email)"
                  >content_copy</mat-icon>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #empty>
              <span>-</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <!-- state Column -->
        <ng-container matColumnDef="amount">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Сумма</mat-header-cell>
          <mat-cell *matCellDef="let element">
                <span
                  matTooltip="{{element.amount | fastCoinsToDollar}}"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="!isGoFast"
                >{{element.amount / 100 | number }}</span></mat-cell>
        </ng-container>

        <!-- method Column -->
        <ng-container matColumnDef="method">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Метод</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span
              matTooltip="System: {{element.system || '-'}}"
              matTooltipPosition="above"
            >{{ element.method }}{{ element.system ? ' (' + element.system + ')' : '' }}</span>
            <span *ngIf="element.method === 'market' && element.fast_deliver === false" matTooltip="player-to-player">&nbsp;P2P</span>
          </mat-cell>
        </ng-container>

<!--        &lt;!&ndash; email Column &ndash;&gt;-->
<!--        <ng-container matColumnDef="email">-->
<!--          <mat-header-cell *matHeaderCellDef mat-sort-header>E-mail</mat-header-cell>-->
<!--          <mat-cell *matCellDef="let element">-->
<!--            <ng-container *ngIf="element.email; else emptyEmail">-->
<!--              <div class="email-container">-->
<!--                <a class="link" [routerLink]="['/payouts/wallet/', element.email]">-->
<!--                  <span class="text-overflow">{{element.email}}</span></a>-->
<!--                <mat-icon class="icon"-->
<!--                          matTooltip="Нажми чтобы скопировать"-->
<!--                          matTooltipPosition="above"-->
<!--                          (click)="clipboard.copy(element.email)"-->
<!--                >content_copy</mat-icon>-->
<!--              </div>-->
<!--            </ng-container>-->
<!--            <ng-template #emptyEmail>-->
<!--              <span>-</span>-->
<!--            </ng-template>-->
<!--          </mat-cell>-->
<!--        </ng-container>-->

        <!-- name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Предмет</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.name else refillByMoney">
              <div class="item-container"
                   matTooltip="{{element.name}}"
                   matTooltipPosition="above">
                <div class="img-box" *ngIf="element.img">
                  <img class="image" [src]="element.img" alt="item-icon">
                </div>
                <ng-container *ngIf="getItemNames(element.name) as items">
                  <div class="item-name text-overflow">{{ items.slice(0, 2).join(', ') }}</div>
                  <span class="item-more" *ngIf="items.length > 2">+{{ items.length - 2 }}</span>
                </ng-container>
              </div>
            </ng-container>
            <ng-template #refillByMoney>
              <img src="../../../../../assets/images/fastcoin.svg" alt="fastcoin">
              <span>&nbsp; Fast Coins</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <!-- timestampAdded Column -->
        <ng-container matColumnDef="timestamp">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Создан</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.timestamp | date: 'dd.MM.yy HH:mm:ss'}} </mat-cell>
        </ng-container>

        <!-- msg Column -->
        <ng-container matColumnDef="msg">
          <mat-header-cell *matHeaderCellDef>MSG</mat-header-cell>
          <mat-cell *matCellDef="let element"><span class="text-overflow"
                                                    matTooltip="{{element.msg}}"
                                                    matTooltipPosition="above"
          >{{element.msg || '-'}}</span></mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="refillColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: refillColumns;" [ngClass]="{'our-bot': row.isOurBot}" ></mat-row>

        <div class="empty-data" *matNoDataRow>
          <p>Данные отсутствуют</p>
        </div>
      </mat-table>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
      <mat-paginator [pageSizeOptions]="[20, 50, 100]"></mat-paginator>
    </ng-template>

    <ng-template #hltvTable>
      <mat-table [dataSource]="userRefills" class="table refill-table" matSort>

        <!-- orderId Column -->
        <ng-container matColumnDef="orderId">
          <mat-header-cell *matHeaderCellDef>ID</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.orderId}} </mat-cell>
        </ng-container>

        <!-- amount Column -->
        <ng-container matColumnDef="amount">
          <mat-header-cell *matHeaderCellDef>Сумма</mat-header-cell>
          <mat-cell *matCellDef="let element"><span>{{element.amount / 100 | currency: 'USD'}}</span></mat-cell>
        </ng-container>

        <!-- system Column -->
        <ng-container matColumnDef="system">
          <mat-header-cell *matHeaderCellDef>Провайдер</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.transaction?.system}} </mat-cell>
        </ng-container>

        <!-- timestampAdded Column -->
        <ng-container matColumnDef="timestampAdded">
          <mat-header-cell *matHeaderCellDef>Создан</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.timestampAdded | date: 'dd.MM.yy HH:mm:ss'}} </mat-cell>
        </ng-container>

        <!-- ip Column {{element.ip}}-->
        <ng-container matColumnDef="ip">
          <mat-header-cell *matHeaderCellDef>IP</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <a [routerLink]="['../../check/ip/', element.ip]">{{ element.ip }}</a>
          </mat-cell>
        </ng-container>

        <!-- recievedAmount Column -->
        <ng-container matColumnDef="recievedAmount">
          <mat-header-cell *matHeaderCellDef>Получено</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.currency then withCurrencyCode; else withoutCurrencyCode"></ng-container>
            <ng-template #withCurrencyCode>
              <span>{{element.transaction?.recievedAmount  | currency: element.currency.toUpperCase(): 'symbol-narrow' }}</span>
            </ng-template>
            <ng-template #withoutCurrencyCode>{{element.transaction?.recievedAmount}}</ng-template>
          </mat-cell>
        </ng-container>

        <!-- status Column -->
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Статус</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.transaction?.status}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="data">
          <mat-header-cell *matHeaderCellDef>Data</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button mat-button color="primary" [disabled]="!element.transaction?.userData"
                    (click)="openUserData(element.transaction.userData)">
              <mat-icon>info</mat-icon>
            </button>
          </mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="refillColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: refillColumns;" [ngClass]="{paid: row.isPaid}"></mat-row>

        <div class="empty-data" *matNoDataRow>
          <p>Данные отсутствуют</p>
        </div>
      </mat-table>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
      <mat-paginator [pageSizeOptions]="[20, 50, 100]"></mat-paginator>
    </ng-template>

  </div>
</div>
